import * as actionTypes from '../Actions/actionTypes';

// Application State
const initialState = {
    appTitle:"AVAFin",
    sidebarShow:true,
    presentationMode:false,
    nightMode:false,
    activeMenu:"Home",
    activeSubMenu:"",
    activeURI:"",
    fullLoad:false,

}


const updateActiveURIResult = (state, action)=>{
    state.activeURI = action.data;
    return state;
}

const updateActiveMenuResult = (state, action)=>{
    state.activeMenu = action.data;
    return state;
}

const updateActiveSubMenuResult = (state, action)=>{
    state.activeSubMenu = action.data;
    return state;
}

const toggleSidebar = (state, action)=>{
    state.sidebarShow = !state.sidebarShow;
    return state;
}

const togglePresentationMode = (state, action)=>{
    state.presentationMode = !state.presentationMode;

    return state;
}

const toggleNightMode = (state, action)=>{
    state.nightMode = !state.nightMode;
    return state;
}
const onChangeFullLoading = (state,action)=>{
    state.fullLoad = !state.fullLoad;
    return state;
}

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TOGGLE_SIDEBAR:
            return toggleSidebar(state,action);
        case actionTypes.PRESENTATION_MODE:
            return togglePresentationMode(state,action);
        case actionTypes.NIGHT_MODE:
            return toggleNightMode(state,action);
        case actionTypes.UPDATE_ACTIVE_MENU:
            return updateActiveMenuResult(state,action);
        case actionTypes.UPDATE_ACTIVE_SUBMENU:
            return updateActiveSubMenuResult(state,action);
        case actionTypes.UPDATE_ACTIVE_URI:
            return updateActiveURIResult(state,action);
        case actionTypes.CHANGE_FULL_LOADING:
            return onChangeFullLoading(state,action);
       
        default:
            return { ...state}
    }
}



export default appReducer;